import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

import { promotionKeys } from "./query-keys";

type BulkArchiveBody = components["schemas"]["BulkArchiveRequest"];

/** POST /v1/promotions/bulk-archive. Invalidate, no optimism (spec §6). */
export function useBulkArchive() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body: BulkArchiveBody) => {
      const { data, error } = await apiClient.POST("/v1/promotions/bulk-archive", { body });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: promotionKeys.all });
    },
  });
}
